/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */
/*
 * ---------------------------------------------------------------------------------
 * Functions
 * ---------------------------------------------------------------------------------
 */
/**
 * This function is used to combine logics.
 * @param logics logics to be combined.
 * @returns the combined logics.
 */
var combineLogics = function (logics) {
    var logicNames = Object.keys(logics);
    if (logicNames.length === 0) {
        return [];
    }
    var logic = [];
    for (var _i = 0, logicNames_1 = logicNames; _i < logicNames_1.length; _i++) {
        var logicName = logicNames_1[_i];
        logic = logic.concat(logics[logicName]);
    }
    return logic;
};
/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */
export default combineLogics;
//# sourceMappingURL=combineLogics.js.map